function getEnvVariable(key) {
  return process.env[`REACT_APP_${key}`]
}

export { getEnvVariable }
